import { resolveUnref } from '@vueuse/core'
import {computed} from 'vue'
import {useTeam} from '@/composables/useTeam'

export function useOdds (odds, game) {
  const oddsNames = {
    'X': '무승부',
    '1X': '1팀승/무승부',
    '12': '1팀승/2팀승',
    'X2': '2팀승/무승부',
    '1/YES': '1팀승/양득',
    'X/YES': '무승부/양득',
    '2/YES': '2팀승/양득',
    '1/NO': '1팀승/무득',
    'X/NO': '무승부/무득',
    '2/NO': '2팀승/무득',
    '1/O': '1팀승/오버',
    '1/U': '1팀승/언더',
    'X/O': '무승부/오버',
    'X/U': '무승부/언더',
    '2/O': '2팀승/오버',
    '2/U': '2팀승/언더',
    '1/1': '1팀승/1팀승',
    '1/X': '1팀승/무승부',
    '1/2': '1팀승/2팀승',
    'X/1': '무승부/1팀승',
    'X/X': '무승부/무승부',
    'X/2': '무승부/2팀승',
    '2/1': '2팀승/1팀승',
    '2/X': '2팀승/무승부',
    '2/2': '2팀승/2팀승',
    'YES': '예',
    'NO': '아니오',
    'OVER': '오버',
    'UNDER': '언더',
    '1ST QUARTER': '1쿼터',
    '2ND QUARTER': '2쿼터',
    '3RD QUARTER': '3쿼터',
    '4TH QUARTER': '4쿼터',
    '1ST HALF': '전반전',
    '2ND HALF': '후반전',
    'PERIOD 1': '1피리어드',
    'PERIOD 2': '2피리어드',
    'PERIOD 3': '3피리어드',
  }

  function replaceName (name) {
    const resolved = resolveUnref(game)
    if (name === '1') {
      return resolved.home_team.name_ko
    }
    if (name === '2') {
      return resolved.away_team.name_ko
    }

    return name
      .replace('#1', resolved.home_team.name_ko)
      .replace('#2', resolved.away_team.name_ko)
      .replace('OVER', '오버')
      .replace('UNDER', '언더')
  }

  function getName (name) {
    return oddsNames[name?.toUpperCase()] || replaceName(name?.toUpperCase())
  }

  function getIcon (name) {
    const resolved = resolveUnref(game)
    const { getIcon } = useTeam()

    if (['1', '#1'].includes(name)) {
      return getIcon(resolved.home_team)
    }
    if (['2', '#2'].includes(name)) {
      return getIcon(resolved.away_team)
    }
  }

  function getValue (value) {
    return Number(value).toFixed(2)
  }

  const name = computed(() => {
    const resolved = resolveUnref(odds)

    return getName(resolved.n)
  })

  const icon = computed(() => {
    const resolved = resolveUnref(odds)

    return getIcon(resolved.n)
  })

  const value = computed(() => {
    const resolved = resolveUnref(odds)

    return getValue(resolved.v)
  })

  const locked = computed(() => {
    const resolved = resolveUnref(odds)

    return Boolean(resolved.locked) || Number(value.value) <= 1
  })

  return {
    name,
    icon,
    value,
    locked
  }
}
